import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const PageLoader = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top after route change
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
      });
    });
  }, [pathname]);

  return <></>;
};
